import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '~gc/shared/services/config.service';
import { ROLES_MAP } from '../../domains/app/auth/auth.maps';
import { InvitedUser, UserType } from '../../domains/users';
import { Connection, Source } from '../../domains/users/connection/connection.model';
import { USER_ROLES } from '../../domains/users/types';
import { UserQuery } from './models/user-query.model';

@Injectable()
export class InvitesService {
  constructor(
    private http: HttpClient,
    private readonly config: ConfigService,
  ) {}

  lookupUserByEmail(email: string, type: UserType) {
    return this.http.get<UserQuery>(`${this.config.host}/users/query/${email}?type=${type}`);
  }

  addNewUser(user: InvitedUser): Observable<{ userId: string }> {
    const role = USER_ROLES[user.role];
    return this.http.post<{ userId: string }>(`${this.config.host}/users/invite`, {
      ...user,
      role: ROLES_MAP[role],
    });
  }

  sendUserInvite(invite: { email: string; source: Source }): Observable<Connection> {
    return this.http.post<Connection>(`${this.config.host}/my-network/invite`, invite);
  }
}
